<template>
  <modal>
    <div class="modal-content">
      <h2 class="message text-center text-lg font-bold mb-2">リカバリーコード入力</h2>
      <p class="message text-center text-sm mb-2">リカバリーコードを入力して「送信」を押してください</p>
      <input type="text" v-model="recoveryCode" class="input-station" />
    </div>
    <div class="modal-button flex justify-between">
      <a @click="$emit('closeRecoveryCode')" class="button-secondary block w-half">{{ $t('cancel') }}</a>
      <a class="button-primary block w-half" @click="submitRecoveryCode">
        送信
      </a>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    Modal
  },
  data () {
    return {
      recoveryCode: undefined
    }
  },
  methods: {
    submitRecoveryCode: function () {
        this.$gtag.event("リカバリーコード入力", {
          date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
          token: this.$store.getters['user/getToken']
        });
      this.$store.dispatch('loading/beginLoading')
      this.$emit('closeRecoveryCode')
      this.$store.dispatch('plans/recoveryToken', this.recoveryCode)
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    },
    closeRecoveryCode: function () {
      this.$emit('closeRecoveryCode')
    }
  }
}
</script>
